import React, { Suspense, lazy } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/flaticon.css";
import "./styles/boxicons.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "swiper/css";
import "swiper/css/bundle";
import "react-tabs/style/react-tabs.css";
import "./styles/faq.css";

// Global Style
import "./styles/global.css";
import "./styles/style.css";
import "./styles/header.css";
import "./styles/footer.css";
import "./styles/responsive.css";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ScrollToTop from './layouts/scroll.layout';
import ContactoPage from './pages/contacto.page';
import NosotrosPage from './pages/nosotros.page';
import ProductosPage from './pages/productos.page';
import ProductoPage from './pages/producto.page';

const HomePage = lazy(() => import('./pages/home.page'));
const NotFound: React.FC = () => {
  return (
    <div>
      <header className="App-header">
        <h1>404 - Página no encontrada</h1>
        <p>Lo sentimos, la página que buscas no existe.</p>
        <Link to="/" className="App-link">
          Volver al inicio
        </Link>
      </header>
    </div>
  );
}

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Suspense envuelve los componentes con lazy loading */}
        <Suspense fallback={<div>Cargando...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/productos" element={<ProductosPage />} />
            <Route path="/producto/:product" element={<ProductoPage />} />
            <Route path="/nosotros" element={<NosotrosPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
